import React, { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";

import "../../../Styles/authentication.css";
import "../../../Styles/typography.css";

import { ReactComponent as HeaderLogo } from "../../../Assets/Images/LandingPage/subjects-master-logo.svg";
import { ReactComponent as ButtonArrow } from "../../../Assets/Images/Button/btn_arrow.svg";
import { ReactComponent as FacebookIcon } from "../../../Assets/Images/Header/Facebook.svg";
import { ReactComponent as InstaIcon } from "../../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../../Assets/Images/Header/TikTok.svg";
import { SOCIAL_MEDIA_LINKS, Api, URL_LOGIN, generateValidationSchema } from "Helpers";

import MobileHeader from "Components/Header/MobileHeader";
import CustomButton from "Components/Commons/CustomButton/CustomButton";
import { InputWithLabel } from "Components/Commons";

import { InputLabel, Box } from "@material-ui/core";
import { useFormik } from "formik";

// STYLES
import { PageWrapper } from "./ResetPassword.style";

// CONST
const inputs = [
	{
		label: "Password",
		name: "password",
		type: "password",
		validation: { required: true, min: 6 },
	},
	{
		label: "Confirm Password",
		name: "confirmPassword",
		type: "password",
		validation: { required: true, equals: "password" },
	},
];

const validationSchema = generateValidationSchema(inputs);

const initialValues = { password: "", confirmPassword: "" };

function ResetPassword() {
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	let { token } = useParams();

	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit: resetPassword,
	});

	function resetPassword(values) {
		setIsLoading(true);
		let data = new FormData();
		data.append("token", token);
		data.append("newPassword", values.password);

		new Api().post("user/resetPassword", { data }).then(() => {
			setIsLoading(false);
			navigate(URL_LOGIN);
		});
	}

	return (
		<PageWrapper>
			<div className="login-regi-wrapper">
				{/* LEFT SIDE */}
				<div className="auth-wrap-left">
					<div className="auth_wrap_logo">
						<MobileHeader />
						<Link to="/" className="desktop_logo_login">
							<HeaderLogo />
						</Link>
					</div>
					<div className="auth_wrap_left_in">
						<h1>
							Welcome to <br /> <span className="redfont">Subjects Master</span>
						</h1>
						<p>
							Oops! Reset your password? Don’t worry—you can easily reset it and
							get back to your learning adventure. Just enter your details, and
							we’ll unlock your account so you can continue exploring.
						</p>
					</div>
				</div>

				{/* RIGHT SIDE */}
				<div className="auth_wrap_right">
					<div className="menu_other_buttons">
						<div className="social_handles">
							<ul>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.FACEBOOK} target="_blank" rel="noopener noreferrer">
										<FacebookIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
										<InstaIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.TIKTOK} target="_blank" rel="noopener noreferrer">
										<TiktokIcon />
									</a>
								</li>
							</ul>
						</div>
						<div className="portal_login_link">
							<Link to="/teacher/login">Portal Login</Link>
						</div>
						<div className="logins_btn">
							<Link to="/login" className="customs_btn">
								Login <span><ButtonArrow /></span>
							</Link>
						</div>
					</div>

					<div className="auth_right_inner">
						<div className="auth_right_head">
							<h2>Reset Password</h2>
							<h4 className="redfont">Oops! Let’s Unlock Your Account.</h4>
						</div>

						<form onSubmit={formik.handleSubmit} className="reset_password_wrapper">
							<Box className="content">
								<Box>
									<Box className="flex-column-parent">
										{inputs.map((input) => (
											<Box key={input.name} className="flex-column field_wrapper">
												{/* Label */}
												<Box component="Box" sx={{ display: "inline" }} className="text">
													<InputLabel className="text">{input.label}</InputLabel>
												</Box>

												{/* Input */}
												<InputWithLabel
													id={input.name}
													name={input.name}
													className="full-width"
													type={input.type}
													placeholder={input.label}
													value={formik.values[input.name]}
													onChange={formik.handleChange}
													onBlur={formik.handleBlur}
													signupform={true}
												/>

												{/* Validation Error */}
												<Box
													component="div"
													sx={{ display: "inline", height: "10px" }}
													className="validation-error text"
												>
													{formik.touched[input.name] && formik.errors[input.name]
														? formik.errors[input.name]
														: ""}
												</Box>
											</Box>
										))}
									</Box>
								</Box>

								<div className="login_btn_divs">
									<Box className="login-button-parent">
										<CustomButton
											text={isLoading ? "Loading..." : "Reset Password"}
											className="button"
											type="submit"
											isLoading={isLoading}
										/>
									</Box>
								</div>
							</Box>
						</form>
					</div>
				</div>
			</div>
		</PageWrapper>
	);
}

export default ResetPassword;
